import { ConstructorSchema } from '@common/mapper/types';
import { dtoToModelSchemas } from '@/app/platform/platform-core/user/mapper/dto-to-model-schemas';

export const userMapperSchemas: ConstructorSchema<any, any>[] = [...dtoToModelSchemas];
